import { __assign } from 'tslib';
import React__default, { memo } from 'react';
import { dataViewElementsAuthorizedIconsConfiguration, dataViewElementsThumbnailSizeConfiguration, dataViewElementsElementIdDisplayRuleConfiguration, dataViewElementsVisualAlertConfiguration, tagsConfigurationAtom, customerCommonOverrideAtom, currentLocaleAtom, fetcherModeAtom, activeBusinessFiltersState, currentFolderRootBreadcrumbContext, FetcherMode, useDataViewElement, useDataViewElementLinks, useDataViewElementButtons, useFilterReset, getCustomerOverrideFunction, FunctionOverrideKey, DataViewKey, ELEMENT_SUMMARY_ID_PREFIX, ActionValue, Position, MediaField, createFolderBusinessFilter } from '@keepeek/commons';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import isNil from 'lodash/isNil';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import DefaultIcon from '../../DefaultIcon/index.js';
import ElementSummary from '../../ElementSummary/index.js';
import { classes as classes$1 } from '../../ElementSummary/index.styled.js';
import FormatElementId from '../../FormatElementId/index.js';
import FormatTechnicalFields from '../../FormatTechnicalFields/index.js';
import { DisplayMode } from '../../FormatTechnicalFields/FormatTechnicalFolders.js';
import ElementActions from '../Elements/ElementActions/index.js';
import ElementDuration from '../Elements/ElementDuration/index.js';
import ElementLinks from '../Elements/ElementLinks/index.js';
import { ElementsMetaField } from '../Elements/ElementsMetaField/index.js';
import IconOverMedia from '../Elements/IconOverMedia/index.js';
import Tags from '../Tags/index.js';
import { getTagsDataByPosition } from '../Tags/utils/getTagsDataByPosition.js';
import { getVisualAlertsDataByPosition } from '../Tags/utils/getVisualAlertsDataByPosition.js';

var PREFIX = "MemoizedElementSummary";
var classes = {
    root: "".concat(PREFIX, "-root"),
    tagBottomLeft: "".concat(PREFIX, "-tagBottomLeft"),
    tagBottomRight: "".concat(PREFIX, "-tagBottomRight"),
    tagBottomLeftUnderElement: "".concat(PREFIX, "-tagBottomLeftUnderElement"),
    tagBottomRightUnderElement: "".concat(PREFIX, "-tagBottomRightUnderElement")
};
var StyledElementSummary = styled(ElementSummary)(function (_a) {
    var _b, _c;
    var showFields = _a.showFields;
    return (__assign(__assign(__assign({}, (!showFields && { position: "relative" })), (_b = {}, _b["&.".concat(classes.root)] = {
        display: "flex",
        flexDirection: "column",
        "& > div:last-child": {
            flex: 1,
            display: "flex",
            flexDirection: "column"
        }
    }, _b["& .".concat(classes.tagBottomLeft)] = {
        alignItems: "flex-start"
    }, _b["& .".concat(classes.tagBottomRight)] = {
        alignItems: "flex-end"
    }, _b["& .".concat(classes.tagBottomLeftUnderElement)] = {
        position: "absolute",
        bottom: 0,
        left: 0
    }, _b["& .".concat(classes.tagBottomRightUnderElement)] = {
        position: "absolute",
        bottom: 0,
        right: 0
    }, _b)), (!showFields && (_c = {},
        _c["& .".concat(classes$1.cardContent)] = {
            padding: 0
        },
        _c[".MuiCardContent-root:last-child"] = {
            padding: 0
        },
        _c))));
});
var MemoizedElementSummary = function (_a) {
    var _b, _c;
    var id = _a.id, shareTokenDownloadAuthorized = _a.shareTokenDownloadAuthorized, sentryCallback = _a.sentryCallback, openElementCallback = _a.openElementCallback, _d = _a.KIcon, KIcon = _d === void 0 ? DefaultIcon : _d, enabledActions = _a.enabledActions, _e = _a.allowSelection, allowSelection = _e === void 0 ? true : _e, allowNavigation = _a.allowNavigation, dataViewKey = _a.dataViewKey, onDoubleClick = _a.onDoubleClick, onActionClick = _a.onActionClick, _f = _a.showFields, showFields = _f === void 0 ? true : _f, _g = _a.useImgComponent, useImgComponent = _g === void 0 ? false : _g, imageMaxHeight = _a.imageMaxHeight, actionButtonsColor = _a.actionButtonsColor, attachmentsVisible = _a.attachmentsVisible;
    var t = useTranslation("refront-components").t;
    var authorizedIcons = useRecoilValue(dataViewElementsAuthorizedIconsConfiguration);
    var thumbnailSize = useRecoilValue(dataViewElementsThumbnailSizeConfiguration);
    var elementIdDisplayRule = useRecoilValue(dataViewElementsElementIdDisplayRuleConfiguration);
    var visualAlertsConfiguration = useRecoilValue(dataViewElementsVisualAlertConfiguration);
    var tagsConfiguration = useRecoilValue(tagsConfigurationAtom);
    var isTagEnabled = tagsConfiguration !== null &&
        (tagsConfiguration === null || tagsConfiguration === void 0 ? void 0 : tagsConfiguration.tagsToDisplayId) !== null &&
        ((_b = tagsConfiguration === null || tagsConfiguration === void 0 ? void 0 : tagsConfiguration.tagsToDisplayId) === null || _b === void 0 ? void 0 : _b.length) !== 0;
    var customerCommonOverride = useRecoilValue(customerCommonOverrideAtom);
    var currentLocale = useRecoilValue(currentLocaleAtom);
    var fetcherMode = useRecoilValue(fetcherModeAtom);
    var filters = useRecoilValue(activeBusinessFiltersState(dataViewKey));
    var setCurrentFolderId = useSetRecoilState(currentFolderRootBreadcrumbContext);
    var isShare = fetcherMode === FetcherMode.SHARE;
    var _h = useDataViewElement({
        key: dataViewKey,
        id: id,
        sentryCallback: sentryCallback,
        openElementCallback: openElementCallback,
        filters: filters
    }), element = _h.element, isSelected = _h.isSelected, functionalFieldsToDisplayBeforeCustomerHook = _h.functionalFieldsToDisplay, technicalFieldsToDisplay = _h.technicalFieldsToDisplay, loadingFields = _h.loadingFields, selectionMode = _h.selectionMode, singleSelection = _h.singleSelection, click = _h.click, doubleClick = _h.doubleClick, actionClick = _h.actionClick, majClick = _h.majClick, associationClick = _h.associationClick;
    var _j = useDataViewElementLinks({
        key: dataViewKey,
        id: id,
        filters: filters,
        attachmentsVisible: attachmentsVisible
    }), showMediaLinkLink = _j.showMediaLinkLink, showAttachmentLink = _j.showAttachmentLink;
    var _k = useDataViewElementButtons({
        key: dataViewKey,
        id: id,
        isShare: isShare,
        shareTokenDownloadAuthorized: shareTokenDownloadAuthorized,
        filters: filters,
        enabledActions: enabledActions,
        attachmentsVisible: attachmentsVisible
    }), showAttachmentButton = _k.showAttachmentButton, showAddToBasketButton = _k.showAddToBasketButton, showShareButton = _k.showShareButton, showDownloadButton = _k.showDownloadButton, showInsertButton = _k.showInsertButton, showRemoveFromBasketButton = _k.showRemoveFromBasketButton, showThumbnailGeneratorButton = _k.showThumbnailGeneratorButton;
    var resetFilters = useFilterReset(dataViewKey);
    function handleCardClick(e) {
        if (selectionMode) {
            // Detect keyboard shortcut
            // Shift pressed during the click
            if (e.shiftKey) {
                majClick();
            }
            else {
                click();
            }
        }
    }
    // In case the id doesn't match an element in the store
    if (!element) {
        return null;
    }
    var visualAlertsDataByPosition = isTagEnabled
        ? undefined
        : getVisualAlertsDataByPosition(visualAlertsConfiguration, element, currentLocale);
    var tagsDataByPosition = isTagEnabled
        ? getTagsDataByPosition(tagsConfiguration, element.labels, isNil(tagsConfiguration === null || tagsConfiguration === void 0 ? void 0 : tagsConfiguration.visibleTagsCount) ? 3 : tagsConfiguration === null || tagsConfiguration === void 0 ? void 0 : tagsConfiguration.visibleTagsCount)
        : undefined;
    var tagsToDisplay = visualAlertsDataByPosition || tagsDataByPosition;
    var tagsToDisplayInBottom = getTagsToDisplayInBottom(showFields, tagsToDisplay);
    var functionalFieldsToDisplay = getCustomerOverrideFunction(FunctionOverrideKey.FunctionalFieldsToDisplayQueryOut, {
        element: element,
        functionalFieldsToDisplayBeforeCustomerHook: functionalFieldsToDisplayBeforeCustomerHook
    }, customerCommonOverride) || functionalFieldsToDisplayBeforeCustomerHook;
    function handleFolderClick(folder) {
        var _a;
        setCurrentFolderId(undefined); // Remove current folderId to get root from hierarchy
        var businessFilter = createFolderBusinessFilter(folder.id, (_a = folder === null || folder === void 0 ? void 0 : folder.title) !== null && _a !== void 0 ? _a : "", t("components.business-filter.advanced.folder.label"), folder.path);
        resetFilters({
            exceptFolderFilter: false,
            exceptBasketFilter: dataViewKey === DataViewKey.BASKET_DETAIL,
            filterToAddAfterReset: businessFilter
        });
    }
    var fieldsToDisplay = (React__default.createElement(React__default.Fragment, null,
        (elementIdDisplayRule === null || elementIdDisplayRule === void 0 ? void 0 : elementIdDisplayRule.identifier) && (React__default.createElement(FormatElementId, { element: element, elementIdRules: elementIdDisplayRule })),
        React__default.createElement(ElementsMetaField, { fields: functionalFieldsToDisplay, media: element, dataViewKey: dataViewKey, KIcon: KIcon }),
        React__default.createElement(Box, { sx: { flex: 1 } }),
        React__default.createElement(FormatTechnicalFields, { element: element, technicalFieldsToDisplay: technicalFieldsToDisplay, folderDisplayMode: dataViewKey === DataViewKey.BASKET_DETAIL
                ? DisplayMode.FIRST_FOLDER_WITHOUT_LINK
                : DisplayMode.FIRST_FOLDER_WITH_LINK, onFolderClick: handleFolderClick, KIcon: KIcon })));
    return (React__default.createElement(StyledElementSummary, { id: "".concat(ELEMENT_SUMMARY_ID_PREFIX).concat(id), className: classes.root, imageMaxHeight: imageMaxHeight, element: element, isSelected: isSelected, showFields: showFields, onSelect: function () {
            if (!selectionMode) {
                click();
            }
        }, onNavigate: function () {
            actionClick(ActionValue.OPEN_ELEMENT);
            onActionClick(ActionValue.OPEN_ELEMENT);
        }, actions: function () { return (React__default.createElement(ElementActions, { displayShowThumbnailGeneratorAction: showThumbnailGeneratorButton, displayAddToBasketAction: showAddToBasketButton, displayRemoveFromBasketAction: showRemoveFromBasketButton, displayDownloadAction: showDownloadButton, displayShareAction: showShareButton, displayShowAttachmentButton: showAttachmentButton, displayInsertAction: showInsertButton, onActionClick: function (value) {
                actionClick(value);
                onActionClick(value);
            }, KIcon: KIcon, buttonsColor: actionButtonsColor })); }, links: showFields && (showAttachmentLink || showMediaLinkLink) ? (React__default.createElement(ElementLinks, { actionClick: function (action) {
                actionClick(action);
                onActionClick(action);
            }, associationClick: associationClick, displayAttachmentsButton: showAttachmentLink, displayMediaLinksButton: showMediaLinkLink })) : undefined, allowSelection: allowSelection && (!isShare || (isShare && shareTokenDownloadAuthorized)), selectionMode: selectionMode, singleSelection: singleSelection, cardDoubleClicked: function () {
            doubleClick();
            onDoubleClick();
        }, cardClick: handleCardClick, useImgComponent: useImgComponent, iconOverMedia: React__default.createElement(IconOverMedia, { element: element, KIcon: KIcon, authorizedIcons: authorizedIcons }), topLeftElement: (tagsToDisplay === null || tagsToDisplay === void 0 ? void 0 : tagsToDisplay.has(Position.TopLeft)) ? (React__default.createElement(Tags, { tagsPosition: Position.TopLeft, tagsData: tagsToDisplay.get(Position.TopLeft) || [] })) : null, topRightElement: (tagsToDisplay === null || tagsToDisplay === void 0 ? void 0 : tagsToDisplay.has(Position.TopRight)) ? (React__default.createElement(Tags, { tagsPosition: Position.TopRight, tagsData: (tagsToDisplay === null || tagsToDisplay === void 0 ? void 0 : tagsToDisplay.get(Position.TopRight)) || [] })) : null, bottomLeftElement: (_c = element === null || element === void 0 ? void 0 : element.fields) === null || _c === void 0 ? void 0 : _c.map(function (f) {
            if (((element === null || element === void 0 ? void 0 : element.mediaType.startsWith("video/")) || (element === null || element === void 0 ? void 0 : element.mediaType.startsWith("audio/"))) &&
                f.id === MediaField.DURATION_IN_SECONDS.toString()) {
                return React__default.createElement(ElementDuration, { key: f.id, value: f.value });
            }
            else {
                return null;
            }
        }), loadingContent: loadingFields, imageSize: thumbnailSize, allowNavigation: allowNavigation, KIcon: KIcon }, showFields || tagsToDisplayInBottom.length > 0 ? (React__default.createElement(React__default.Fragment, null,
        showFields && fieldsToDisplay,
        tagsToDisplayInBottom)) : null));
};
/**
 * Get tags to display in the bottom of the card
 * @param showFields
 * @param tags
 */
var getTagsToDisplayInBottom = function (showFields, tags) {
    var ret = [];
    tags === null || tags === void 0 ? void 0 : tags.forEach(function (currentTags, position) {
        if (position === Position.BottomLeft || position === Position.BottomRight) {
            var bottomTagClass = void 0;
            if (showFields) {
                bottomTagClass =
                    position === Position.BottomLeft ? classes.tagBottomLeft : classes.tagBottomRight;
            }
            else {
                bottomTagClass =
                    position === Position.BottomLeft
                        ? classes.tagBottomLeftUnderElement
                        : classes.tagBottomRightUnderElement;
            }
            ret.push(React__default.createElement(Tags, { key: position === null || position === void 0 ? void 0 : position.toString(), className: bottomTagClass, tagsPosition: position, tagsData: currentTags || [] }));
        }
    });
    return ret;
};
var MemoizedElementSummary$1 = memo(MemoizedElementSummary);

export { MemoizedElementSummary$1 as default };
//# sourceMappingURL=index.js.map
